export enum SidenavModeTypes{
    Dropdown = 1,
    Infinite = 2,
}